import React from 'react';
import { Container } from '@mui/material';
import RelatorioRomaneioBase from '../components/relatorios/RelatorioRomaneioBase';
import { relatorioRomaneioService } from '../services/relatorioRomaneio';

const RelatorioDiferencaRomaneioSaidas: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <RelatorioRomaneioBase
        titulo="Relatório - Diferença entre Itens no Romaneio e em Saídas"
        gerarRelatorio={relatorioRomaneioService.imprimirDiferencaRomaneioSaidas}
        getFilename={(id) => `Romaneio_${id}.xlsx`}
      />
    </Container>
  );
};

export default RelatorioDiferencaRomaneioSaidas;
